import React, { Component } from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'

class Calendar extends Component {
  static propTypes = {
    inside: PropTypes.bool,
    right: PropTypes.bool,
    noClick: PropTypes.bool,
    gray: PropTypes.bool,
    isWidgetIcon: PropTypes.bool,
    onClick: PropTypes.func
  }

  render () {
    const { inside, right, noClick, gray, isWidgetIcon } = this.props
    const classes = classNames({
      'icon--img': true,
      'calendar-icon': true,
      widget__icon: isWidgetIcon,
      'icon--gray': gray,
      'icon--right': right,
      'icon--inside': inside,
      'icon--no-click': noClick
    })

    return (
      <div className={'icon ' + classes} onClick={this.props.onClick}>
        <svg viewBox='0 0 24 24'>
          <path
            className='icon__fill'
            fill='#67B0E7'
            d='M19,19H5V8H19M16,1V3H8V1H6V3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3H18V1M17,12H12V17H17V12Z'
          />
        </svg>
      </div>
    )
  }
}

export default Calendar
